import React from 'react';
import Translation from '../translation/translation';

function LightBoxUILockHeader() {
    return (
        <div className="fsf__app-header fsf-app-header">
            <Translation
                translationKey="fsf-header-general-title"
                className="fs-remove-light-box-header__headline"
            />
        </div>
    );
}

export { LightBoxUILockHeader };
